module.exports = __webpack_public_path__ + "img/logo.4c82cbe3.png";